@if (definition$ | async; as definition) {
  <soft-dynamic-form
    [value]="value$ | async"
    [definition]="$any(definition)"
    (formSubmit)="onSubmit($event ?? {})"
    #form
  ></soft-dynamic-form>
  <div class="flex flex-row justify-end mt-4">
    <button
      class="soft-button primary"
      [disabled]="saving$ | async"
      (click)="onSubmit(form.form().value)"
      >
      @if (saving$ | async) {
        <i class="fa-regular fa-spinner fa-spin"></i>
      }
      {{ '#UTILITIES.SETTINGS.USER_CONTACT.SUBMIT' | translate }}
    </button>
  </div>
} @else {
  @if (loading$ | async) {
    <soft-loading-spinner></soft-loading-spinner>
  }
  <div class="flex flex-row justify-center">
    @if (!(loading$ | async)) {
      <h5 class="font-semibold color light">
        {{ '#UTILITIES.SETTINGS.USER_CONTACT.NO_DEFINITION' | translate }}
      </h5>
    }
  </div>
}
